import React from "react";
import { useState, useEffect } from "react";
import { useSelector } from "react-redux";
import useSnackbar from "../../../hooks/useSnackbar";
import { getTransactionDocShippingaddress } from "../../../api/transaction-type";

import { slugMap } from "../../../config/slug-config";
import { useParams } from "react-router-dom";
import {
  Box,
  Grid,
  CircularProgress,
} from "@mui/material";
import { CustomCheckBox } from "../../../components/CheckboxComp";

export default function ItemFullfillmentShipping({ tabIndexP }) {
  const snackbar = useSnackbar();
  const { data: user } = useSelector((state) => state.user);
  const params = useParams();
  const [loading, setLoading] = useState(false);
  const [rowData, setRowData] = useState([]);

  useEffect(() => {
    if (user.token && tabIndexP === 1) {
      getTransactionShippingAddressData();
    }
  }, [tabIndexP]);

  async function getTransactionShippingAddressData() {
    setLoading(true);
    try {
      const { data } = await getTransactionDocShippingaddress(user?.token, {
        id: params.docNo,
      });
      setRowData(data?.data?.data[0]);
      // setTrackingnumberData(data.data.trackingnumber);
      setLoading(false);
      //return { rows: data.data.data, total: data.data.total, error: false };
    } catch (error) {
      console.log(error);
      snackbar.showError("Error In Loading Data.");
      setLoading(false);
      return { error: true };
    } finally {
      setLoading(false);
    }
  }

 return loading ? (
       <>
           <Box className="viewDetilsBox">
             <Grid container className="mb-2">
               <Grid item xs={12}>
                 <div
                   style={{
                     width: "100%",
                     display: "flex",
                     justifyContent: "center",
                     alignItems: "center",
                   }}
                 >
                   <CircularProgress></CircularProgress>
                 </div>
               </Grid>
             </Grid>
           </Box>
       </>
     ) : (
      <Box className="viewDetilsBox">
                    <Grid container className="mb-2">
                      <Grid item xs={12} sm={6}>
                        <Grid container>
                          <Grid item xs={12} md={12} className="m-b-10">
                            <p className="titleHeading m-0">Shipping Information</p>
                          </Grid>
                          <Grid item xs={12} className="m-b-10">
                            <p className="tFormlabel">SHIPPING CARRIER</p>
                            <p className="tFormName">{rowData?.shippingcarrier}</p>
                          </Grid>
                          <Grid item xs={12} className="m-b-10">
                            <p className="tFormlabel">SHIPPING METHOD</p>
                            <p className="tFormName">{rowData?.shippingmethod}</p>
                          </Grid>
                        </Grid>
                      </Grid>
                      <Grid item xs={12} sm={6}>
                        <Grid container className="mb-2">
                          <Grid item xs={12} md={12} className="m-b-10">
                            <p className="titleHeading m-0">Shipping Address</p>
                          </Grid>
                          <Grid item xs={12}>
                            <p className="tFormlabel">ADDRESS</p>
                            <p className="tFormName">{rowData?.shippingaddress}</p>
                          </Grid>
      
                         < CustomCheckBox title={"RESIDENTIAL ADDRESS"} data={rowData?.residentialaddress} />
                        </Grid>
                      </Grid>
                    </Grid>
                  </Box>
  );
}
